export default __webpack_public_path__ + "../staticImages/weinfass-260.png";